"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.bruteForceIndex = void 0;
/**
 * A brute force (not very performant or fuzzy-search capable) index that matches permutation expressions with string.includes()
 *
 * @param suggestions
 */
function bruteForceIndex(suggestions) {
    return function (text) {
        if (!text)
            return [];
        var predicate = function (segment) { return segment.toLowerCase().includes(text.toLowerCase()); };
        return suggestions.filter(function (permutationExpression) { return matches(permutationExpression, predicate); });
    };
}
exports.bruteForceIndex = bruteForceIndex;
function matches(suggestion, predicate) {
    return !!suggestion.segments.find(function (segment) {
        return typeof segment === 'string' ? predicate(segment) : !!segment.find(predicate);
    });
}
//# sourceMappingURL=bruteForceIndex.js.map